import type { Components, Theme } from '@mui/material/styles'

import { fontSize, spacing } from '@/themes/tokens'

export const MuiTextFieldOverride: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'outlined',
    size: 'medium',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiOutlinedInput-root': {
        borderRadius: theme.spacing(spacing.sm),
      },
      '& .MuiInputLabel-root': {
        fontSize: fontSize.sm,
      },
      '& .MuiFilledInput-root': {
        borderRadius: theme.spacing(spacing.sm),
      },
    }),
  },
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme }) => ({
        '& .MuiOutlinedInput-input': {
          padding: theme.spacing(spacing.sm),
        },
      }),
    },
    {
      props: { size: 'medium' },
      style: ({ theme }) => ({
        '& .MuiOutlinedInput-input': {
          padding: theme.spacing(spacing.input),
        },
      }),
    },
  ],
}
